export const USER_MANAGEMENT_STATUS = {
  bondai_applicant_status_approved: "Approved",
  bondai_applicant_status_pending_approval: "Pending",
  bondai_applicant_status_applied: "Applied",
  bondai_applicant_status_invited: "Invited",
  bondai_applicant_status_duplicate: "Duplicate",
  bondai_applicant_status_verified: "Verified",
  bondai_applicant_status_validated: "Validated",
  bondai_applicant_status_expired: "Expired",
  bondai_applicant_status_error: "Error",
  bondai_applicant_status_rejected: "Rejected",
  bondai_applicant_status_activated: "Activated",
  bondai_applicant_status_manual: "Manual",
};
